<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading"
           @on-cancel="cancel"
           :width="700"
           :ok-text="'确定'"
    >
      <h3 slot="header" class="modal-header">查看解约申请</h3>
      <div class="mb16" style="font-weight: bold" v-if="data">
        <span>房间：{{data.stockNumbers}}</span>
      </div>
      <div style="margin-bottom: 50px" v-if="data">
        <Row class="row">
          <Col span="3">申请日期</Col>
          <Col span="4">解约类型</Col>
          <Col span="5">预计退租日期</Col>

          <Col span="4">失效日期</Col>
          <Col span="2">申请人</Col>
          <Col span="3">状态</Col>
          <Col span="3">操作</Col>
        </Row>
        <Row class="row">
          <Col span="3">{{data.createTime ||'-'}}</Col>
          <Col span="4">
            <Select v-model="surType" @on-change="surExpectDate=''">
              <!--              <Option value="">请选择</Option>-->
              <Option v-for="(item,index) in options" :key="'keyA'+index" :value="item.value" >{{item.text}}</Option>
            </Select>
          </Col>
          <Col span="5">
            <DatePicker type="date" v-model="surExpectDate" @on-change="surExpectDate=$event" placeholder="yyyy-mm-dd" :options="dateOptions"></DatePicker>
          </Col>

          <Col span="4">{{data.surApplyInvalidDate ||'-'}}</Col>
          <Col span="2">{{data.createBy || '-'}}</Col>
          <Col span="3">{{data.surApplyStatusCn || '-'}}</Col>

          <Col span="3">
            <a href="javascript:;" @click="closeItem" v-p="{api:'surrender/closeUnRentApply'}"> 关闭</a>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {checkRentApply,closeUnRentApply,updateUnRentApply} from "../../../../api/contractList";

  export default {
    name: "ReleaseApplyView",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      contractFid:{
        type:String,
        default:''
      }
    },
    watch: {
      n() {
        this.cleanData()
        this.checkRentApply()
        this.isShow = true
      }
    },
    computed:{
      dateOptions() {
        if(!this.res){
          return null

        }

        // NORMAL(0, "正常退租"),
        //   ABNORMAL(1, "非退"),
        //   ONE_SIDED(2, "单方面解约"),
        //   THREE_DAYS_NOT_SATISFIED(3, "三天不满意"),
        //   EXCHANGE_RENT(4, "换租"),
        //   SUBLET(5, "转租"),
        //   NO_RESPONS(6, "无责退"),
        //   COMPANY_DEFAULT(7, "公司违约"),
        //   OVERDUE(8, "逾期解约"),
        //   CLEAR_BACK(9, "清退"),
        //   ONE_SIDED_PRE_CONSTARTDATE(10, "单方面解约(起租日前)");

        let start = this.currentTimestamp, end=null
        if([1,2,4,5,6,7,9].indexOf(this.surType)!==-1){
          end = this.res.conEndDate;
        }
        if(this.surType===0){
          // end=new Date(Number(this.conEndDateOneDate))
          end=this.res.conEndDateOneDate

        }
        if(this.surType===3){
          end=this.res.conStartSixDate;
        }
        if(this.surType===10){
          // end=new Date(Number(this.conStartDateOneDate))
          end=this.res.conStartDateOneDate
        }
        if(this.surType===8){
          end=this.res.conOverDate
        }

        return {
          disabledDate(date) {
            if(end){
              return date && (date.valueOf()<(start-86400000)  ||  date.valueOf()>end)
            }
            else {
              return date.valueOf()<(start-86400000)
            }
          },
          // start:start,
        }
      }

    },
    data() {
      return {
        surType:'',
        surExpectDate:null,
        loading: true,
        isShow: false,
        data:null,
        options:[],
        res:null,
        currentTimestamp:0
      }
    },
    methods: {
      cleanData(){
        this.surType=''
        this.options=[]
        this.data=null

        this.res=null
      },
      closeItem(){
        this.$Modal.confirm({
          title:'关闭解约申请',
          content:'<p>确认关闭？</p>',
          onOk:()=>{
            let params={
              contractFids:this.data.contractFids
            }
            closeUnRentApply(params).then(res=>{
              this.$Message.success('关闭解约申请成功')
              this.$emit('closedone')
              this.isShow=false
            }).catch(error=>{})
          }
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if(this.data.contractFids && (this.surType || this.surType===0) && this.surExpectDate){
          let params={
            contractFids:this.data.contractFids,
            surExpectDate:this.surExpectDate,
            surType:this.surType,
          }
          updateUnRentApply(params).then(res=>{
            //增加提示不关闭窗口
            if (res.data.errorCode == 1) {
              this.$Message.error(res.data.errorMsg);
              this.changeLoading();
              return;
            }
            this.$Message.success('修改成功')
            this.isShow=false
          }).catch(error=>{
            this.isShow=false
          })
        }else {
          this.$Message.info("预计退租日期或解约类型不能为空")
          this.changeLoading()
        }
      },
      checkRentApply(){
        let params={
          contractFid:this.contractFid
        }
        checkRentApply(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data.unRentApplyInfoVo
          this.options=res.data.surrenderTypeEnums
          this.surType=this.data.surType,
          this.surExpectDate=this.data.surExpectDate

          this.res=res.data
          this.currentTimestamp=res.currentTimestamp


        }).catch(error=>{
          this.isShow=false
        })
      },
      cancel() {
      }
    }

  }
</script>

<style scoped>
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
